import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const GENDER = ['male', 'female', 'other', 'n/a']
const INVITE = ['not_invite', 'invite']

export const schema = Joi.object().keys({
	tName: Joi.string().required(),
	tPhone: Joi.string().allow(''),
  tGender: Joi.string().valid(GENDER).required(),
	tEmail: Joi.string().allow(''),
  invite_or_not: Joi.string().allow(''),
  photo: Joi.object(),  
});

export default function registerTeacher(schoolId, teacherInfo ) {

  if(!schoolId){
    throw 'Missing school ID'
  }

  let validateResult = Joi.validate(teacherInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }
  let toServer = {
    ...teacherInfo,
    tGender: GENDER.indexOf(teacherInfo.tGender),
  }

  if (toServer.photo) {
    return updateWithUpload(schoolId, toServer);
  } else {
    return update(schoolId, toServer);
  }
}

function updateWithUpload(schoolId, toServer) {
  let API_URL
  if (process.env.APP_ENV == 'development') {
    API_URL = 'https://saas.classtop.com:3001/sapi';
  } else {
    API_URL = 'https://school.classtop.com:3001/sapi';
  }

  return new Promise((resolve, reject) => {
    let data = new FormData();
    
    _.each(toServer, (value, name)=>{
      if (name === 'photo') {
        data.append('photo', toServer.photo, 'photo');
      }else if (typeof value !== 'undefined') {
        data.append(name, value);
      }
    });

    axios.post(API_URL + '/rgst_tch/' + schoolId + '/', data, {
      headers: {
        'Authorization': 'JWT ' + localStorage.getItem('token'),
        'Content-Type': 'multipart/form-data',
      }
    })
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
      console.error(err)
    });

  });

}

function update(schoolId, toServer) {
  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/rgst_tch/${schoolId}/`,
		'method': 'POST',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/teacher/registerTeacher.js